import { defineComponent, PropType } from 'vue'
import type { Options as OffsetOptions } from '@floating-ui/core/src/middleware/offset'
import Popover from './Popover'
import { Placement, Trigger } from '../../enums'

export default defineComponent({
  inheritAttrs: false,
  props: {
    content: {
      type: String,
      default: undefined,
    },
    target: {
      type: Object as PropType<HTMLElement>,
      default: undefined,
    },
    placement: {
      type: String as PropType<Placement>,
      default: 'top',
    },
    offset: {
      type: [Number, Object, Function] as PropType<OffsetOptions>,
      default: undefined,
    },
    arrow: {
      type: Boolean,
      default: true,
    },
    trigger: {
      type: String as PropType<Trigger>,
      default: 'hover',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    validate: {
      type: Function as PropType<() => boolean>,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    change(visible: boolean) {
      return visible !== undefined
    },
  },
  setup(props, { slots, attrs, emit }) {
    return () => <Popover
      target={props.target}
      placement={props.placement}
      offset={props.offset}
      arrow={props.arrow}
      trigger={props.trigger}
      visible={props.visible}
      validate={props.validate}
      disabled={props.disabled}
      class={attrs.class}
      style={attrs.style}
      {
        ...{
          onChange(v: boolean) {
            emit('change', v)
          },
        }
      }
      v-slots={{
        default: slots.default,
        tooltip: slots.content || (props.content && (() => props.content)),
      }}
    />
  },
})
